/***/
$(document).ready(function(){
   // $(window).scroll(function(){
   //  setTimeout(function(){
   //    if( $('.shopify-section-group-header-group').hasClass('scrolled-past-header')){
   //       $('.shopify-section-group-header-group'.removeClass('scrolled-past-header');
   //     }
   //  }, 500);
   // });
 
  // $(document).on('click','.see_reviews_summary_popup',function() {
  //   $('button#yotpo-summary').click()
  // });
  
  $('.free-select-radio').on('click',function() {
      $('.free-modal-radio').find('.hw-select').hide();
      $('.free-select-radio').prop('checked', false);
      $('.popup-main-div.booster').removeClass('b-one-free');
      $('.popup-main-div.booster').removeClass('b-two-free');
      $('.free-modal-radio').removeClass('active');
      $(this).parents('.free-modal-radio').addClass('active');
      $(this).prop('checked', true);
      $(this).parents('.free-modal-radio').find('.hw-select').show();
      
      $(".booster .select-product").not('.first-product').removeClass('selected');

      if($(this).hasClass('two-free')){
        $('.popup-main-div.booster').addClass('b-two-free');
        $('.pcount').show();
        $('.count-text').html('/ 2 samplers selected');
        $(".booster .select-product").not('.first-product').find('.sampler-icon-add').show();
        $(".booster .select-product").not('.first-product').find('.sampler-price').hide();
        $('.boostersubmit').prop('disabled', false).removeClass('disabled');
        $('.boostersubmit .main-free').hide();
        $('.boostersubmit .price-main').show();
        $(".booster .select-product").not('.first-product').find('p').html('Complimentary Sample');
        $('.boostersubmit .m-price').html($('.free-modal-radio.active .final-price-boost').html());
         $('.sticky_atc_btn').html('Add To Cart - '+ $('.free-modal-radio.active .final-price-boost').html());
      }
      else{
        $('.popup-main-div.booster').addClass('b-one-free');
        $('.pcount').hide();
        $('.count-text').html('1 samplers selected');
        $('.boostersubmit').prop('disabled', false).removeClass('disabled');
        $(".booster .select-product").not('.first-product').find('.sampler-price').show();
        $('.boostersubmit .main-free').hide();
        $('.boostersubmit .price-main').show();
        $(".booster .select-product").not('.first-product').find('p').html('Individual perfume sample');
        $('.boostersubmit .m-price').html($('.free-modal-radio.active .final-price-boost').html());
         $('.sticky_atc_btn').html('Add To Cart - '+ $('.free-modal-radio.active .final-price-boost').html());
        // var demotext = $('.free-modal-radio.active').find('.demo-sampler').html().replace('Free','').replace('Included','');
        // $('.free-modal-radio.active').find('.demo-sampler').html(demotext);
       
      }
    $('.bcount').html('1');
    selectedProducts = []; selectedDiv = [];
    var firstPro = $(".booster .select-product:first-child").data('product-id');
     selectedProducts.push(firstPro);
     selectedDiv.push(0);
    $('.free-modal-radio .other-sampler').html('');
      
  });
var selectedProducts = []; var selectedDiv = [];
  var firstPro = $(".booster .select-product:first-child").data('product-id');
   selectedProducts.push(firstPro);
   selectedDiv.push(0);
  
   $(document).on('click','.b-two-free .select-product', function() { 
   
        var productId = $(this).data('product-id');
  
        var index = selectedProducts.indexOf(productId);
        var finalindex = $(this).parents('.b-two-free').find('.select-product').index(this);

       if (!$(this).hasClass('selected')) {          
              selectedDiv.push(finalindex);
              selectedProducts.push(productId);
              $(this).addClass('selected');
              
          } else {
              selectedProducts.splice(index, 1);
              $(this).removeClass('selected');
              selectedDiv.splice( $.inArray(finalindex, selectedDiv), 1 );
          }
     if(selectedProducts.length == 2){
       $('.b-two-free').find('.sampler-icon-add').hide();
       $('.b-two-free').find('.sampler-price').show();
       $(".b-two-free .select-product").not('.first-product').find('p').html('Individual perfume sample');
       $.each( selectedDiv, function( key, value ) {
            
         $('.b-two-free .select-product').eq(value).find('.sampler-icon-add').show();
         $('.b-two-free .select-product').eq(value).find('.sampler-price').hide();
          $(".b-two-free .select-product").eq(value).find('p').html('Complimentary Sample');
        });
       $('.b-two-free .select-product').eq(0).find('.sampler-icon-add').show();
         $('.b-two-free .select-product').eq(0).find('.sampler-price').hide();
        $('.pcount').show();
        $('.pcount').html('2');
       $('.count-text').html('/ 2 samplers selected');
      
     }
      else if(selectedProducts.length > 2){
        $(".b-two-free .select-product").not('.first-product').find('p').html('Individual perfume sample');
        $('.b-two-free').find('.sampler-icon-add').hide();
       $('.b-two-free').find('.sampler-price').show();
       $.each( selectedDiv, function( key, value ) {
        console.log(key)
         $('.b-two-free .select-product').eq(value).find('.sampler-icon-add').show();
         $('.b-two-free .select-product').eq(value).find('.sampler-price').hide();
         if(key < 2){
           $(".b-two-free .select-product").eq(value).find('p').html('Complimentary Sample');
         }
         else{
            $(".b-two-free .select-product").eq(value).find('p').html('Individual perfume sample');
         }
         
        
        });
       $('.b-two-free .select-product').eq(0).find('.sampler-icon-add').show();
         $('.b-two-free .select-product').eq(0).find('.sampler-price').hide();
         $('.pcount').hide();
        $('.count-text').html(selectedDiv.length + ' samplers selected');
      
      }
     else{
        $('.b-two-free').find('.sampler-icon-add').show();
        $('.b-two-free').find('.sampler-price').hide();
        $('.pcount').html('1');
        $(".b-two-free .select-product").not('.first-product').find('p').html('Complimentary Sample');
     }

    });


$(document).on('click','.b-one-free .select-product', function() { 
   
        var productId = $(this).data('product-id');
  
        var index = selectedProducts.indexOf(productId);
        var finalindex = $(this).parents('.b-one-free').find('.select-product').index(this);

       if (!$(this).hasClass('selected')) {          
              selectedDiv.push(finalindex);
              selectedProducts.push(productId);
              $(this).addClass('selected');
             
              
          } else {
              selectedProducts.splice(index, 1);
              $(this).removeClass('selected');
              selectedDiv.splice( $.inArray(finalindex, selectedDiv), 1 );
            
          }

$('.b-one-free').find('.sampler-icon-add').hide();
       $('.b-one-free').find('.sampler-price').show();
       $.each( selectedDiv, function( key, value ) {

         $('.b-one-free .select-product').eq(value).find('.sampler-icon-add').show();
         $('.b-one-free .select-product').eq(value).find('.sampler-price').hide();
        });

    });

$(document).on('click','.popup-main-div .b-selection', function(e) { 
  $('.free-modal-radio.active .other-sampler').html('');
  $('.popup-main-div').removeClass('active');
  $('body').removeClass('popup-wrapper-container');
  $('.boostersubmit').prop('disabled', false).removeClass('disabled');
  var count = parseInt(selectedDiv.length)-2;

  if((selectedProducts.length >1)){
    $('.bcount').html('2');
  }
  if($('.booster').hasClass('b-two-free')){
  jQuery.each(selectedProducts, function(key, value) {
    if(key>0){
       var title = $('.booster .select-product[data-product-id='+value+']').data('title');
      $('.free-modal-radio.active .other-sampler').append('<div class="sampler-data"><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_850_356)"><path d="M6.40501 12.1864L2.13501 7.9214L6.40501 12.1864ZM6.40501 12.1864L13.865 4.72141" stroke="#161616" stroke-width="1.25" stroke-miterlimit="10"/></g><defs><clipPath id="clip0_850_356"><rect width="16" height="16" fill="white" transform="translate(0 0.451416)"/></clipPath></defs></svg><span>'+title+'</span><span class="s-edit">Edit</span><span class="s-delete" data-varid='+value+'>Delete</span></div>');
      if(selectedProducts.length > 1 && key == 1 && count > 0){
        $('.free-modal-radio.active .other-sampler').append('<span class="s-additional">'+count+' Additional Sampler</span>');
      }
    }
   
  });
  }
  else{
    jQuery.each(selectedProducts, function(key, value) {
     if(key>0){
       var count1 = parseInt(selectedDiv.length)-1;
       var title = $('.booster .select-product[data-product-id='+value+']').data('title');
       if(key == 1){
        $('.free-modal-radio.active .other-sampler').append('<span class="s-additional">'+count1+' Additional Sampler</span>');
       }
      $('.free-modal-radio.active .other-sampler').append('<div class="sampler-data"><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_850_356)"><path d="M6.40501 12.1864L2.13501 7.9214L6.40501 12.1864ZM6.40501 12.1864L13.865 4.72141" stroke="#161616" stroke-width="1.25" stroke-miterlimit="10"/></g><defs><clipPath id="clip0_850_356"><rect width="16" height="16" fill="white" transform="translate(0 0.451416)"/></clipPath></defs></svg><span>'+title+'</span><span class="s-edit">Edit</span><span class="s-delete" data-varid='+value+'>Delete</span></div>');
      
    }
    });
    // $('.free-modal-radio.active').find('.demo-sampler').prepend("Free ");
    // $('.free-modal-radio.active').find('.demo-sampler').append(" Included");
  }
var currency = $('.boostersubmit').data("currency");
var originalProductPrice = $('.free-modal-radio.active').data('price');
  
if($('.booster').hasClass('b-one-free')){
  originalProductPrice = 0;
  var counter = 0;
}
else{
   var counter = 2;
}

  var totalPrice = originalProductPrice;
    var selectedCount = 0; 
    $('.select-product.selected').each(function() {
        if (selectedCount >= counter) {
            var productPrice = parseFloat($(this).data('price'));
            totalPrice += productPrice;
        }
        selectedCount++;
    });
    totalPrice = totalPrice/100;
    $('.boostersubmit .m-price').text(currency + totalPrice.toFixed(2));
    $('.sticky_atc_btn').html('Add To Cart - '+currency + totalPrice.toFixed(2));
  
 });

  $(document).on('click','.s-delete', function(e) { 
    var deleteid = $(this).data('varid');
    $('.booster .select-product[data-product-id='+deleteid+']').removeClass('selected');
     var index = selectedProducts.indexOf(deleteid);
    selectedProducts.splice(index, 1);
    var finalindex =  $('.booster .select-product[data-product-id='+deleteid+']').index('.select-product');
    selectedDiv.splice( $.inArray(finalindex, selectedDiv), 1 );
    if($('.booster').hasClass('b-two-free')){
    $('.booster .select-product[data-product-id='+deleteid+']').find('.sampler-icon-add').hide();
    $('.booster .select-product[data-product-id='+deleteid+']').find('.sampler-price').show();
    }
    else{
      $('.booster .select-product[data-product-id='+deleteid+']').find('.sampler-icon-add').hide();
      $('.booster .select-product[data-product-id='+deleteid+']').find('.sampler-price').show();
    }
    $(this).parent('.sampler-data').remove();
    if($('.booster').hasClass('b-two-free')){
    if((selectedProducts.length == 2)){
       $('.free-modal-radio.active .other-sampler').find('.s-additional').remove();
    }
    }
    else{
    if((selectedProducts.length == 1)){
       $('.free-modal-radio.active .other-sampler').find('.s-additional').remove();
    }
    else{
       var count2 = parseInt(selectedDiv.length)-1;
      $('.free-modal-radio.active .other-sampler').find('.s-additional').html(count2+' Additional Sampler');
    }
      
    }
   if((selectedProducts.length == 1)){
    $('.bcount').html('1');
    
     if($('.booster').hasClass('b-two-free')){
    $('.booster .select-product').find('.sampler-icon-add').show();
    $('.booster .select-product').find('.sampler-price').hide();
    }
    else{
     
    }
    }


    var currency = $('.boostersubmit').data("currency");
    var originalProductPrice = $('.free-modal-radio.active').data('price');
      
    if($('.booster').hasClass('b-one-free')){
      originalProductPrice = 0;
      var counter = 0;
    }
    else{
       var counter = 2;
    }

    var totalPrice = originalProductPrice;
    var selectedCount = 0; 
    $('.select-product.selected').each(function() {
        if (selectedCount >= counter) {
            var productPrice = parseFloat($(this).data('price'));
            totalPrice += productPrice;
        }
        selectedCount++;
    });
    totalPrice = totalPrice/100;
    if($('.booster').hasClass('b-one-free')){
     
          $('.boostersubmit .m-price').text(currency + totalPrice.toFixed(2));
          $('.sticky_atc_btn').html('Add To Cart - '+currency + totalPrice.toFixed(2));
      
    }
    else{
        $('.boostersubmit .m-price').text(currency + totalPrice.toFixed(2));
        $('.sticky_atc_btn').html('Add To Cart - '+currency + totalPrice.toFixed(2));
    }
  
  });

   $('.boostersubmit').on('click', function(e) {
      $('.main-cart-drawer').addClass('loading-data');
      setTimeout(function(){
        $('.main-cart-drawer').removeClass('loading-data');
      },3000);
     e.preventDefault();  
     var mainID = $('.orignal-pro').val();

      var bundleID  = getRandomTenDigit();
      var items = [];
      if($('.booster').hasClass('b-two-free')){

        jQuery.each(selectedDiv, function(key, value) {
          var variant_id = parseInt($('.b-two-free').find('.select-product').eq(value).attr("data-product-id"));
           if((key  == 0) || (key == 1)){
               items.push({
                    quantity: 1,
                    id: variant_id,
                    properties: {
                      "Product": "Free Gift",
                      "bundle products" : "bundle-"+bundleID,
                    }
                  });  
            }
            if(key > 1){
                items.push({
                    quantity: 1,
                    id: variant_id,
                     properties: {
                      "bundle products" : "bundle-"+bundleID
                    }
                  });  
            };
         
          });

        var main = {
          quantity: 1,
          id:parseInt(mainID),
          properties: {
          "_bundle products" : "bundle-"+bundleID
          }
        }
      items.push(main);
        
      }
        else{

          jQuery.each(selectedDiv, function(key, value) {
          var variant_id = parseInt($('.b-one-free').find('.select-product').eq(value).attr("data-product-id"));
         
                items.push({
                    quantity: 1,
                    id: variant_id
                  });  
  
          });
        }
     console.log(items);
        $.ajax({
            type: 'POST',
            async: false,
            url: '/cart/add.js',
            data: {items: items},
            dataType: 'json',
            success: function() {
            // console.log('Items added to cart');
            $('cart-drawer').addClass('active');
            $('.product-popup-modal').removeAttr("open");
            $('body').addClass('overflow-hidden');
            $("cart-drawer").load(location.href + " cart-drawer>*","");
            $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*",""); 
            $('cart-drawer').removeClass('is-empty');
            if($('html').scrollTop() >= 100){
              var height = $('header').outerHeight();
              $('cart-drawer.drawer').css({"top":height+"px", "height":'calc(100% - ' + height + 'px)'});         
             }
            // drawerfunction(); 
             setTimeout(function(){
                  drawerfunction();
               },1500);
            },
            error: function() {
                console.log('Error adding items to cart');
            }
        });
     
   });

async function fetchAndReplaceHtml(newContentBlock) {
  // debugger;
    const url = window.Shopify.routes.root + 'cart?section_id=main-cart-items';
    const response = await fetch(url);
    const responseText = await response.text();
    const newHtml = new DOMParser().parseFromString(responseText, "text/html").getElementById('main-cart-items').innerHTML;
    document.getElementById(newContentBlock).innerHTML = newHtml;
    $('cart-drawer').removeClass('is-empty');
    $('cart-drawer').addClass('active');
    $('body').addClass('overflow-hidden');
    return newHtml;
}
// convertUsdToCurrency('firstfreetotal');
// convertUsdToCurrency('thirdfreetotal');
// convertUsdToCurrency('cartlastfreepro');
// convertUsdToCurrency('cartfreeshipdata');
// setTimeout(function(){
//     progressBar();
//  },1000);
 $(document).on("click", ".cf-products-item .element-content.cf-products-item-button", function () {

    $(this).addClass("added-product-cart");
});
 if(window.location.hash && window.location.hash === "#first-bundle-trigger") {
        history.replaceState(null, null, window.location.pathname);
   $(".pick_bundle_item").first().click();
    }

$('product-recommendations ul.quiz-slider').slick({
   slidesToShow: 4,
  slidesToScroll: 1,
    infinite:false,
    arrows:true,
     responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        arrows:true,
        dots:true
        
      }
    },
       {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        dots:true,
        arrows:true
        
      }
    },
       {
      breakpoint: 750,
      settings: {
          centerMode: true,
        slidesToShow: 1.5,
        dots:true,
        arrows:true
        
      }
    },
       {
      breakpoint: 481,
      settings: {
          centerMode: true,
        slidesToShow: 1,
        dots:true,
        arrows:true,
        centerPadding: '75px'
        
      }
    }
       ]
  });
// Reserve main Product page gallery
$('.reserve-product-slider-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical:true,
        asNavFor: '.reserve-product-slider-for',
        dots: false,
        arrows: false,
        focusOnSelect: true,
        verticalSwiping:false

  });
  $('.reserve-product-slider-for').slick({
      arrows: true,
      fade: true,
       infinite: true,
      slidesPerRow: 1,
      slidesToShow: 1,
     dots: true,
      asNavFor: '.reserve-product-slider-nav'
  });

$('.reserve-banner-slideshow').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite:true,
    arrows: false,
    autoplay: false,
    pauseOnHover: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});
  $('.reserve-banner-slideshow').mouseover(function() {
  $(this).slick('pause');
});
  $('.reserve-banner-slideshow').mouseout(function() {
  $(this).slick('play');
});
if ($("body").find("section.reserve-main-product-section").length) {
        $("body").addClass("reserve-header-wrap");
    }

$('body.all-fragrances').each(function() {
    $(".collection_sortList li:first-child a").addClass("active");
     });
  
    $('.drawer__footer .cart_product .card__heading a').each(function() {
      var string = $(this).text().toLowerCase();
      $(this).text(string);
      $(this).css('text-transform','capitalize');
    });

    $('.collection  ul.product-grid h3.card__heading a').each(function() {
      var string = $(this).text().toLowerCase();
      $(this).text(string);
      $(this).css('text-transform','capitalize');
    });


   $(document).on('click','.header  .quickview_btn', function(e) {  
      if ($("body").find("details.menu-drawer-container").length) {
        $("body").addClass("model-menu-opening");
        $("details").addClass("menu-opening");
        $("summary").attr('aria-expanded', true);
        $('.menu-drawer').css('visibility', 'visible');
        $('details.menu-drawer-container').attr('open','');
    }
   });

// POPup add to cart


 $(document).on('click','.choose-popup , .sample-edit-link , .s-edit', function(e) { 
  $('.popup-main-div').addClass('active');
  $('body').addClass('popup-wrapper-container');
 });


 $(document).on('click','.popup-main-div .popup__close', function(e) {  
  if($('.popup-main-div .select-product').hasClass('selected')){
     $('.popup-main-div').removeClass('active');
    $('body').removeClass('popup-wrapper-container');
    
  }else{

    $('.popup-main-div').removeClass('active');
    $('body').removeClass('popup-wrapper-container');
    $('.popup-main-div .select-product').removeClass('selected');
    $('.popup-main-div .popup-product').removeClass('disable');
    $('.pcount').html('0');
    $('.selection').prop('disabled', true).html('Make Selection');
    $('.free-pro-container .popup-product .select-product').prop('disabled', false);
    $('.choosed-popup-data').attr('data-product-id', ' ');
  //  $('.choosed-popup-data .choosed-img img').attr('src', ' ');
    $('.choosed-popup-data .choosed-title').html(' ');
    $('.choosed-popup-data').hide();
    $('.product-free-sample').show();
    // $('.choose-popup').show();
  }
 
 });

    // var selectedDiv = []; 
    $('.fselect-product').on('click', function() {  
      
        var productId = $(this).data('product-id');
        // var index = selectedProducts.indexOf(productId);
        // var finalindex = $(this).parents('.free-pro-container').find('.fselect-product').index(this);
         var finaltext = $(this).text();
 
        if ($(this).hasClass('selected')) {          

              $(this).removeClass('selected');
              $('.free-pro-container .popup-product').removeClass('disable');
              $('.free-pro-container .popup-product .fselect-product').prop('disabled', false);
              // $('.main-btn-add').addClass('disable');
             
              // $('.haspopup .sticky_atc_btn').addClass('disable');
              // $('.haspopup .sticky_atc_btn').html($('.main-btn-add .main-free').html());
              $('.pcount').html('0');
              $('.selection').prop('disabled', true).html('Make Selection');
              $('.sampler-icon-add').text('select');
            }
         else {

            //  $('.free-pro-container .popup-product').addClass('disable');
            //  $('.free-pro-container .popup-product .fselect-product').prop('disabled', true);
            $('.popup-main-div .free-pro-container button.select-product').removeClass('selected');
           $('.sampler-icon-add').text('select');
              $(this).addClass('selected');
              $(this).prop('disabled', false);
          //    $(this).parent('.popup-product').removeClass('disable');
              $(this).find('.sampler-icon-add').text('selected');
              // $('.main-btn-add').removeClass('disable');
             
              // $('.haspopup .sticky_atc_btn').removeClass('disable');
              // $('.haspopup .sticky_atc_btn').html($('.main-btn-add .price-main').html());
               $('.pcount').html('1');
              $('.selection').prop('disabled', false).html('Confirm Selection');
              
        }

  
    });
$(document).on('click','.popup-main-div .p-selection', function(e) {  
 
  var title = $('.fselect-product.selected').data('title');
  var productid = $('.fselect-product.selected').data('product-id');
//  var img = $('.fselect-product.selected').data('src');
  $('.choosed-popup-data .choosed-title').html(title);
  $('.choosed-popup-data').attr('data-product-id', productid);
 // $('.choosed-popup-data .choosed-img img').attr('src', img);
 $('.popup-main-div').removeClass('active');
  $('body').removeClass('popup-wrapper-container');
  $('.choosed-popup-data').css('display','flex');
 $('.product-free-sample').hide();

  // $('.choose-popup').hide();
 });

// 6/12 added start
// if ($('.free-pro-container .popup-product .select-product').prop('disabled') === false) {
//   $(this).parents('.free-modal-wrapper').removeClass('data-added');
// } else {
//     $(this).parents('.free-modal-wrapper').addClass('data-added');
// }
  // 6/12  end
  
$(document).on('click','.sample-delete-link', function(e) { 
 $('.choosed-popup-data').attr('data-product-id', ' ');
// $('.choosed-popup-data .choosed-img img').attr('src', ' ');
 $('.choosed-popup-data .choosed-title').html(' ');
 $('.choosed-popup-data').hide();
   
 // $('.choose-popup').show();
 $('.popup-main-div .select-product').removeClass('selected');
 $('.popup-main-div .popup-product').removeClass('disable');
 $('.pcount').html('0');
 $('.free-pro-container .popup-product .select-product').prop('disabled', false);
 $('.selection').prop('disabled', true).html('Make Selection');
});

  
   $('.main-btn-add').on('click', function(e) {
   
      $('.main-cart-drawer').addClass('loading-data');
      setTimeout(function(){
        $('.main-cart-drawer').removeClass('loading-data');
      },3000);
     e.preventDefault();  

     if($('body').hasClass('product')){
       var mainID = $('.orignal-pro').val(); 
       var firstfreeID = $('.first-free-sampler').val();
     }else{
       var mainID = $(this).parent().find('.orignal-pro').val(); 
       var firstfreeID = $(this).parent().find('.first-free-sampler').val();
     }
       
      var bundleID  = getRandomTenDigit();    
      var freesampleID = $('.popup-main-div .select-product.selected').data('product-id');

     var items = [];
     console.log(freesampleID)
      if(freesampleID){
      var freeSampler = {
          quantity: 1,
          id:parseInt(freesampleID),
          properties: {
          "Product": "Free Gift",
          "_sub products" : "bundle-"+bundleID
          }
        }
      items.push(freeSampler);
      }
     if(firstfreeID){
       var firstSampler = {
          quantity: 1,
          id:parseInt(firstfreeID),
          properties: {
          "Product": "Free Gift",
          "_sub products" : "bundle-"+bundleID
          }
        }
      items.push(firstSampler);
     }
     
       var main = {
          quantity: 1,
          id:parseInt(mainID),
          properties: {         
          "_bundle products" : "bundle-"+bundleID
          }
        }
      items.push(main);
     
      console.log(items)     
        $.ajax({
            type: 'POST',
            async: false,
            url: '/cart/add.js',
            data: {items: items},
            dataType: 'json',
            success: function() {
            console.log('Items added to cart');
              Rebuy.SmartCart.show();             
              setTimeout(function() { 
              if($('.rebuy-cart__flyout #is-a-gift').length == 0){
                $('.rebuy-cart__notes').before($('#is-a-gift'));
              }
            }, 1500);
            // $('cart-drawer').addClass('active');
            // $('.product-popup-modal').removeAttr("open");
            // $('body').addClass('overflow-hidden');
            // $("cart-drawer").load(location.href + " cart-drawer>*","");
            // $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*",""); 
            // $('cart-drawer').removeClass('is-empty');
            // if($('html').scrollTop() >= 100){
            //   var height = $('header').outerHeight();
            //   $('cart-drawer.drawer').css({"top":height+"px", "height":'calc(100% - ' + height + 'px)'});         
            //  }
            // drawerfunction(); 
            
             // setTimeout(function(){
             //     // drawerfunction();    
             //    $('.property-value-bundlecollectionremove .rebuy-cart__flyout-item-remove').click();         
             //   },2000);
            },
            error: function() {
                console.log('Error adding items to cart');
            }
        });
     
   });

  // cart drawer remove 

// $(document).on("click", ".property-key-_bundle-products .rebuy-cart__flyout-item-remove", function (e) {
//   $('.rebuy-cart__flyout').addClass('event-none');
//   $(this).parents('.rebuy-cart__flyout-item').addClass('click-active');

//   var subname = $(this).parents('.rebuy-cart__flyout-item').attr('class').split('property-_bundle-products:')[1].replace(' click-active', '');
//   var b_id = parseInt($(this).parents('.rebuy-cart__flyout-item').find('.rebuy-cart__flyout-item-info .proper_properties div').text().split('-')[1]);

//   let dataList = []; // Collect data for multiple items

//   $('.rebuy-cart__flyout-item').each(function () {
//     var lclass = 'property-value-' + subname;

//     if (!$(this).hasClass('click-active') && $(this).hasClass(lclass)) {
//       var Cart_item_cus = window.Rebuy.Cart;

//       for (const [key, value] of Object.entries(Cart_item_cus.items())) {
//         for (const [k, v] of Object.entries(value.properties)) {
//           const variant_trim_val = parseInt(v.split('-')[1]);

//           if (b_id === variant_trim_val) {
//             console.log(`Match found for line: ${key}, Variant: ${variant_trim_val}`);
//             dataList.push({
//               line: parseInt(key), // Shopify line index starts at 1
//               quantity: 0,
//             });
//           }
//         }
//       }
//     }
//   });

//   console.log('Initial Data for removal:', dataList);
//   debugger;
//   // Function to remove items one by one and handle line shifts
//   const removeItemsSequentially = (itemsToRemove) => {
//     if (itemsToRemove.length === 0) {
//       console.log('All items removed successfully');
//       Rebuy.SmartCart.show();
//       $('.rebuy-cart__flyout').removeClass('event-none');
//       return;
//     }

//     const item = itemsToRemove.shift(); // Get the first item
//     jQuery
//       .ajax({
//         url: '/cart/change.js',
//         method: 'POST',
//         dataType: 'json',
//         data: item,
//       })
//       .done(function (updatedCart) {
//         console.log(`Removed item with line ${item.line}`);
//         // Update line numbers in dataList based on the new cart state
//         debugger;
//         updatedCart.items.forEach((cartItem, index) => {
//           const matchingItem = dataList.find((d) => cartItem.properties && parseInt(cartItem.properties.some_property) === b_id); // Replace 'some_property' with the correct property
//           if (matchingItem) {
//             matchingItem.line = index + 1; // Update line to new index
//           }
//         });

//         // Continue removing the next item
//         removeItemsSequentially(itemsToRemove);
//       })
//       .fail(function (error) {
//         console.error('Error removing item:', error);
//         // Continue removing the next item even if there's an error
//         removeItemsSequentially(itemsToRemove);
//       });
//   };

//   if (dataList.length > 0) {
//     removeItemsSequentially(dataList);
//   } else {
//     console.error('No valid data to update the cart');
//     $('.rebuy-cart__flyout').removeClass('event-none');
//   }
// });

  
  // $(document).on("click",".property-key-_bundle-products .rebuy-cart__flyout-item-remove",function(e) {
  //   $('.rebuy-cart__flyout').addClass('event-none');
  //   $(this).parents('.rebuy-cart__flyout-item').addClass('click-active');   
  //    var subname = $(this).parents('.rebuy-cart__flyout-item').attr('class').split('property-_bundle-products:')[1].replace(' click-active',''); 
  //    var b_id = parseInt($(this).parents('.rebuy-cart__flyout-item').find('.rebuy-cart__flyout-item-info').find('.proper_properties div').text().split('-')[1]); 
  //   setTimeout(function(){ 
  //       $('.rebuy-cart__flyout-item').each(function() {  
  //         var lclass = 'property-value-'+subname;   
  //         if(!$(this).hasClass('click-active')){
  //           if($(this).hasClass(lclass)){            
  //              $( '.'+lclass).find('.rebuy-cart__flyout-item-remove').click();  
  //           }
  //         }  
  //         });    
  //       },1500); 
  //   setTimeout(function(){ $('.rebuy-cart__flyout').removeClass('event-none'); },3000);   
  // });

//   $(document).on("click",".rebuy-cart__flyout-item-minus-button",function(e) {
//     var qty = parseInt($(this).parent().find('.rebuy-cart__flyout-item-quantity-widget-label').html().split('</span>')[1]);  
//     if(qty == 1){
//      $(this).parents('.rebuy-cart__flyout-item').find('.rebuy-cart__flyout-item-remove').trigger('click');
//     }
//   });
  
//   $(document).on("click","cart-drawer p.bundle-product-remove",function(e) {
// $('.main-cart-drawer').addClass('loading-data');

// var mainId = $(this).data('id');
// var bundleId = $(this).data('bundle-id');

//     var removeitems = '';
//     $("."+bundleId).each(function() {

//     removeitems = removeitems+ 'updates[' + $(this).data('product-index')+']=0&';
                 
//     });

//   var lengthbundle=$("cart-drawer .cart-drawer .cart-item.bundle-cart-product").length; 
//    var updatedata =  $(".update-data").attr("data-attr-all");

//      $.ajax({
//             type: 'POST',
//             async: false,
//             url: '/cart/update.js',
//             data: removeitems,
//             dataType: 'json',
//             success: function() {
//              console.log('Items removed to cart');
//                Rebuy.SmartCart.show();
//             // $('cart-drawer').addClass('active');
//             // $('.product-popup-modal').removeAttr("open");
//             // $('body').addClass('overflow-hidden');
//             // $("cart-drawer").load(location.href + " cart-drawer>*","");
//             // $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*",""); 
//             // $('cart-drawer').removeClass('is-empty');
//             // if($('html').scrollTop() >= 100){
//             //   var height = $('header').outerHeight();
//             //   $('cart-drawer.drawer').css({"top":height+"px", "height":'calc(100% - ' + height + 'px)'});         
//             //  }

//             //   if($("cart-drawer .cart-drawer .cart-item").length == 0){
//             //     $("cart-drawer").addClass("is-empty");
//             //   }
//             //   if ($('.cart-count-bubble').not(':visible')) {
//             //     $('cart-drawer').addClass('is-empty');
//             //   }
//             //   setTimeout(function(){
//             //       // drawerfunction(6);
//             //         var firstfreepro = $('.firstfreepro').val();
//             //         var secondfreepro = $('.secondfreepro').val();
//             //         var thirdfreepro = $('.thirdfreepro').val();
//             //         var removepro1 = $('.progress-free-pro[data-product-index='+firstfreepro+']').data('line-id-cus');
//             //         // var removepro2 = $('.progress-free-pro[data-product-index='+secondfreepro+']').data('line-id');
//             //         var removepro3 = $('.progress-free-pro[data-product-index='+thirdfreepro+']').data('line-id-cus');
        
//             //       // removefreefunction(removepro1,removepro2,removepro3);
//             //           removefreefunction(removepro1,removepro3);
//             //    },1000); 
//             //    setTimeout(function(){
//             //       drawerfunction(7);
//             //    },2500);
//             //   setTimeout(function(){
//             //       cartfetch(); 
                
//             //   },6000);
//             // setTimeout(function(){
//             //     // $('.main-cart-drawer .new-product-item').slick('setPosition'); 
//             //     if($("cart-drawer .cart-drawer .cart-item").length == 0){
//             //       $("cart-drawer").addClass("is-empty");
//             //     }
//             //     $('.main-cart-drawer').removeClass('loading-data');
//             //   },3000);
//             },
//             error: function() {
//                 console.log('Error adding items to cart');
//             }
//         });
 
// });

    // 21-11-2024 nid
function updateCartItems(eventElement) {
     // debugger;    
  
    var subname = eventElement.parents('.rebuy-cart__flyout-item').attr('class').split('property-_bundle-products:')[1];  
  var linename = eventElement.parents('.rebuy-cart__flyout-item').attr('data-key-line');
  console.log(subname+"subname");
  console.log(linename+"linename");
  // if (subname !== undefined && subname.trim() !== '') {
    var removeitems_rebuy_click = '';
  var removeitems_rebuy_click_new = 'updates[' + linename + ']=0&';
    $('.rebuy-cart__flyout-item').each(function() {
        var lclass = $(this).attr('class').split('property-_sub-products:')[1];  
        if(lclass && lclass === subname) {
            var product_another_key = $(this).attr('data-key-line');
          console.log(product_another_key+"product_another_key");
            removeitems_rebuy_click += 'updates[' + product_another_key + ']=0&';
        }        
    });
if (removeitems_rebuy_click !== undefined && removeitems_rebuy_click !== '') {
    // Perform AJAX request
    $.ajax({
        type: 'POST',
        async: false,
        url: '/cart/update.js',
        data: removeitems_rebuy_click_new,
        dataType: 'json',
        success: function() {
            console.log('Items removed from cart');
           $.ajax({
        type: 'POST',
        async: false,
        url: '/cart/update.js',
        data: removeitems_rebuy_click,
        dataType: 'json',
        success: function() {
            console.log('Items removed from cart new');
        },
        error: function() {
            console.log('Error adding items to cart new');
        }
    });
        },
        error: function() {
            console.log('Error adding items to cart');
        }
    });

}
  // }
}

  $(document).on("click", ".rebuy-cart__flyout-item-remove", function(e) {
    // Call the shared function
    updateCartItems($(this));
    $('[data-rebuy-component=checkout-area] .rebuy-button').addClass('event-none');
   setTimeout(function() {  
     $('[data-rebuy-component=checkout-area] .rebuy-button').removeClass('event-none');
   }, 4000);
});

$(document).on("click", ".rebuy-cart__flyout-item-minus-button", function(e) {
    var qty = parseInt($(this).parent().find('.rebuy-cart__flyout-item-quantity-widget-label').html().split('</span>')[1]);  
    if (qty === 1) {
        updateCartItems($(this));
    }
});
  
$(document).on("click", ".rebuy-cart__flyout-item-quantity-widget-button,.rebuy-widget .rebuy-button", function(e) {

 $('[data-rebuy-component=checkout-area] .rebuy-button').addClass('event-none');
 setTimeout(function() {  
   $('[data-rebuy-component=checkout-area] .rebuy-button').removeClass('event-none');
 }, 4000);
});
    // 21-11-2024 nid end

//POPup add to cart end
//cart gift

setInterval(function() {
  const checkbox = $("#gift-wrapping");
  const textareaContainer = $(".textarea-container");
    checkbox.on("change", function() {
      if (checkbox.is("cart-drawer #is-a-gift input#gift-wrapping")) {
        textareaContainer.css("max-height", textareaContainer[0].scrollHeight + "px");
      } else {
        textareaContainer.css("max-height", "0");
     }
  });

// if($('.see_reviews_summary_popup').length == 0 ){
//    $('.product__info-container > .shopify-app-block').append('<span class="see_reviews_summary_popup">See Reviews Summary</span>');
// }
  
}, 3000);

//cart gift

  // $('.mainsubmit').on('click',function(){ 
  //   $('.mainpopup').trigger('click');
  // })

// Showmore Description
$('.show-more-btn').click(function(){
      $('.collection-hero__text-wrapper').toggleClass('button-rotate');
      $('.collection-hero__description').toggleClass('expanded');
      if($('.collection-hero__description').hasClass('expanded')) {
        $(this).text('Show Less');
      } else {
        $(this).text('Show More');
      }
    });
 
if ($('.collection-hero__description').css('-webkit-line-clamp') === '2') {
        $('.collection-hero__text-wrapper').addClass('show-more-btn-box');
    }

// Showmore Description

});

jQuery(function($){
$(document).scroll(function() {
  var y = $(this).scrollTop();
  if (y > 300 && $(window).scrollTop() + $(window).height() < $(document).height() - 100) {
    $('.sticky-footer').addClass('fixed-footer')
  } else {
    $('.sticky-footer').removeClass('fixed-footer')
  }
});
});

jQuery(function($) {
$(window).scroll(function (event) {
    var scroll = $(window).scrollTop();
     if(scroll > 80) {
          $('body').addClass('sticky-cart-drawer-wrap');
     }else {
          $('body').removeClass('sticky-cart-drawer-wrap');
     }
});
});

if($(window).width() < 749){

}
else{
  (function( $ ) {

    $.fn.sameHeight = function() {
        var selector = this;
        var heights = [];
  
        selector.each(function(){
            var height = $(this).height();
            heights.push(height);
        });
  
        var maxHeight = Math.max.apply(null, heights);
  
        selector.each(function(){
            $(this).height(maxHeight);
        }); 
    };
  
  }( jQuery ));
  
  $('.product-client-info .container').sameHeight();
  $(document).ready(function(){
  $('.product-client-info .container').sameHeight();
  });
}

// Custom Home aroma Bundle

  $(document).ready(function(){
      var imgArray = Array();
    
     
$(document).on('click', '.home-aroma-bundle .fragrance-product', function(e) {
    var allProductPrice = 0;
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).text('Add');
        $(this).parents('.popup-product').removeClass('active');
    } else {
        $(this).addClass('active');
        $(this).text('Selected');
        $(this).parents('.popup-product').addClass('active');
    }

    var orignalImg = $('.orignal-img').val();
    var imgArray = [];
    $('.choose_scents_img').removeClass('active');
    $('.choose_scents_img').parent().removeClass('active');
    $('.choose_scents_img').attr('src', orignalImg);

    $('.popup-product.active').each(function() {
        var image = $(this).find('.col_pro_img').attr('src');
        imgArray.push(image);
    });

    $.each(imgArray, function(key, value) {
        var index = key + 1;
        $('.scent_img' + index).attr('src', value);
        $('.scent_img' + index).addClass('active');
        $('.scent_img' + index).parent().addClass('active');
    });

    $('.home-aroma-bundle .fragrance-product.active').each(function(i, e) {
            var productPrice = $(this).data('price');
            allProductPrice += productPrice;
        });

        var selectedProductsCount = $('.home-aroma-bundle .fragrance-product.active').length;
       
        var discountPercentage = 0;
        if (selectedProductsCount >= 2 && selectedProductsCount <= 4) {
            if ($('.disc-qty-' + selectedProductsCount).length > 0) {
                discountPercentage = parseFloat($('.disc-qty-' + selectedProductsCount).data('disc-per'));
            }
        }
        var finalPrice = allProductPrice * (1 - discountPercentage / 100) / 100; 
        var formattedPrice = '$' + finalPrice.toFixed(2);

        $('.main-free').html(formattedPrice); 

        if (selectedProductsCount > 1) {
            $('.bundle_addtocart').prop("disabled", false);
        } else {
            $('.bundle_addtocart').prop("disabled", true);
        }
       
        if (selectedProductsCount < 4) {
            $('.home-aroma-bundle .fragrance-product').prop("disabled", false);
        } else {
            $('.home-aroma-bundle .fragrance-product').not('.active').prop("disabled", true);
        }
        if (selectedProductsCount === 0) {
            $('.main-free').html('Free');
        }

});

$(document).on('click', '.quick-add__submit', function() {
setTimeout(function(){
          $('.quick-add__submit').prop('disabled', true);
        
      },200);
 
  setTimeout(function(){
         $('.quick-add__submit').prop('disabled', false);
        
      },1000);

})
  
    $('.rebuy-cart__flyout-empty-cart a').removeAttr("target");
 setTimeout(function(){    
   
      $('.rebuy-cart__flyout-empty-cart a').removeAttr("target");
    
    },1000);
    setTimeout(function(){    
   
      $('.rebuy-cart__flyout-empty-cart a').removeAttr("target");
    
    },3000);
});
// Custom Home aroma Bundle End
function getRandomTenDigit() {
  return Math.floor(Math.random() * (9999999999 - 1000000000 + 1)) + 1000000000;
}


